import { takeLatest, call, put } from 'redux-saga/effects';
import isNull from 'lodash/isNull';
import isObject from 'lodash/isObject';
import parseApiErrorsToFormik from 'utils/parseApiErrorsToFormik';
import { enqueueSnackbar } from '../notifier/actions';
import {
  updateUserSuccess,
  updateUserError,
  changePasswordSuccess,
  changePasswordError,
} from './actions';
import {
  UPDATE_USER_REQUEST,
  CHANGE_PASSWORD_REQUEST,
  UPDATE_ME,
} from './actionTypes';
import profileService from 'services/ProfileService';
import { HTTP_STATUS_CODES } from 'consts';
import { setSnackbar } from '../snackbar/actions';
import { $t } from '../../translations';

export function* updateUser({
  type,
  firstName,
  lastName,
  avatar,
  meta: { setErrors },
}) {
  try {
    const form = new FormData();
    form.append('first_name', firstName);
    form.append('last_name', lastName);

    if (!isNull(avatar) && isObject(avatar)) {
      form.append('avatar', avatar);
    }

    yield call(profileService.updateProfile, form);
    yield put(updateUserSuccess());
    yield put(
      enqueueSnackbar({
        message: 'user_profile.notification.profile_update',
      })
    );
  } catch (error) {
    if (error.status === HTTP_STATUS_CODES.VALIDATION_FAILED) {
      yield call(setErrors, parseApiErrorsToFormik(error.data.errors));
    }
    yield put(updateUserError());
  } finally {
  }
}

export function* changePassword({
  type,
  currentPassword: current_password,
  newPassword: new_password,
  newPasswordConfirmation: new_password_confirmation,
  meta: { setErrors, resetForm },
}) {
  try {
    yield call(profileService.changePassword, {
      current_password,
      new_password,
      new_password_confirmation,
    });
    yield put(changePasswordSuccess());
    yield call(resetForm);
    yield put(
      enqueueSnackbar({
        message: 'user_profile.notification.password_changed',
      })
    );
  } catch (error) {
    if (error.status === HTTP_STATUS_CODES.VALIDATION_FAILED) {
      yield call(setErrors, parseApiErrorsToFormik(error.data.errors));
    }
    yield put(changePasswordError());
  } finally {
  }
}

export function* updateMe(payload) {
  try {
    yield call(profileService.updateMe, payload.data);
    yield put(
      setSnackbar({
        open: true,
        severity: 'success',
        message: $t('snackbar.message.user.updated'),
      })
    );
  } catch (error) {
    console.log({ error });
  } finally {
  }
}

export default function* userProfileSaga() {
  yield takeLatest(UPDATE_USER_REQUEST, updateUser);
  yield takeLatest(CHANGE_PASSWORD_REQUEST, changePassword);
  yield takeLatest(UPDATE_ME, updateMe);
}
